import React from "react";
import { FlatButton, TextField } from "material-ui";
import UserStore from "../../../stores/UserStore";
import BaseOverlay from "./base.jsx";

class VirtualContentPreviewOverlay extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps) {
    if (
      nextProps.filmId !== this.props.filmId ||
      nextProps.virtualContentId !== this.props.virtualContentId
    ) {
      return true;
    }
    return false;
  }

  render() {
    let { onRequestClose, filmId, virtualContentId } = this.props;
    let user = UserStore.getUser() || {};

    const destination = `${
      process.env.WATCH_SITE_ROOT
    }admin/preview?data=${btoa(
      JSON.stringify({
        film_id: filmId,
        virtual_content_id: virtualContentId,
        ...UserStore.getCredentials()
      })
    )}`;

    return (
      <BaseOverlay
        onRequestClose={onRequestClose}
        useMuiDefaultStyle={true}
        actions={[
          <FlatButton label="Close preview" onTouchTap={onRequestClose} />
        ]}
      >
        <h2 style={{ color: "#000", marginBottom: "1em" }}>
          Virtual content preview
        </h2>
        <div
          style={{ position: "relative", paddingTop: "56.25%", width: "100%" }}
        >
          {/* <div
            style={{
              position: "absolute",
              top: 10,
              width: "100%",
              pointerEvents: "none",
              zIndex: 1,
              color: "rgba(255,255,255,0.7)",
              lineHeight: "0.9",
              textAlign: "center"
            }}
          >
            <div style={{ fontSize: 96 }}>PREVIEW</div>
            <div style={{ fontSize: 36 }}>{user.name || user.organization}</div>
          </div> */}
          <iframe
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%"
            }}
            frameBorder="0"
            scrolling="no"
            ref={r => {
              if (r) {
                r.setAttribute(
                  "allow",
                  "autoplay; encrypted-media; fullscreen"
                );
                r.src = destination;
              }
            }}
          />
        </div>
      </BaseOverlay>
    );
  }
}

export default VirtualContentPreviewOverlay;



// WEBPACK FOOTER //
// ./src/app/components/partials/overlays/virtual-content-preview.jsx